
const BoxShadows = {
	cards: "0px 4px 12px rgba(0, 0, 0, 0.15)"
};

export default BoxShadows;
